import React from 'react';
import { Text, View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { OPPureComponent, ParticipantAvatar, I18n } from '../components';

export default class DisplayParticipant extends OPPureComponent {
  render() {
    const props = this.props;
    const participant = this.props.participant;

    const rank = participant?.profile?.rank;
    const group = participant?.profile?.group;

    if (!participant?.participant) return null;

    return (
      <View style={[styles.container, props.containerStyle]} key={participant.participant.userId}>
        <ParticipantAvatar participant={participant} circleStyles={styles.avatarStyle} />
        <View style={styles.textContainer}>
          <Text style={styles.nameText}>{participant.profile?.fullName}</Text>
          <Text style={styles.detailText}>{rank}</Text>
          <Text style={styles.detailText}>{group}</Text>
        </View>
        {props.children}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    ...THEME.basicRow,
  },
  textContainer: {
    flex: 1,
    marginLeft: 15,
  },
  nameText: {
    ...FONT.bold,
    color: COLOR.text,
    fontSize: 14,
  },
  detailText: {
    ...FONT.regular,
    color: COLOR.text,
    fontSize: 14,
    paddingTop: 5,
  },
  detailTextThick: {
    ...FONT.medium,
    color: COLOR.text,
    fontSize: 14,
    paddingTop: 8,
  },
  avatarStyle: {
    width: 50,
    height: 50,
  },
});
